export interface LoadingOverlayData {
  isLoading?: boolean;
  transparent?: boolean;
}

export interface LoadingOverlayProps extends LoadingOverlayData {}
